/*
 * � 2020 Microsoft. All rights reserved.
 */

define('appInsightsConfig',['ApplicationInsights'], function (ApplicationInsights) {

    AppInsightsConfig = new ApplicationInsights.ApplicationInsights({
        config: {
            instrumentationKey: "4e0ad11e-ab1b-42bb-bb32-d5cc074095da",
            namePrefix: "microsoft.casualgames.microsoftsolitairecollection.appInsights",
            disableAjaxTracking: true
        }
    });

    AppInsightsConfig.loadAppInsights();
    AppInsightsConfig.trackPageView();

    console.info('AppInsightsEvent: ', 'HostingPageLoad');
    AppInsightsConfig.trackEvent({ name: "HostingPageLoad" });

    return AppInsightsConfig;
});
